export const getCompanyId = () =>
  localStorage.getItem("companyId") || localStorage.getItem("company_id") || "";
